export function colorForViewerHash(vid: string): string {
  const hashCode = (str: string): number => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash += str.charCodeAt(i);
    }
    return hash;
  };
  const colors = [
    '#001f3f',
    '#0074D9',
    '#008539',
    '#111111',
    '#1E852A',
    '#207E7E',
    '#348360',
    '#0079A8',
    '#85144b',
    '#737373',
    '#B10DC9',
    '#D80EA9',
    '#EB0C00',
    '#b35300',
    '#7a6a00',
  ];
  return colors[hashCode(vid) % colors.length];
}
